export default __webpack_public_path__ + "static/media/6f080e0e1d2de577.68b9c3a9304a9a3b58076b44d98ea92f.svg";